import {page} from './stores.js';
import {sendEvent} from './tracking.js';

export const asyncQuestionAnsweredEventWithAdTitle = (mappedResult, payload) => {
    if (mappedResult && mappedResult.next) {
        window.addEventListener('beforeunload', e => {
            page.subscribe(value => {
                if (value && typeof value.title !== 'undefined' && value.title !== '') {
                    payload.adTitle = value.title;
                    sendEvent('adLoaded', payload);
                }
            });

            page.load(mappedResult.next);
        }, false);
    }
};
